import config from './config';
import Login from './pages/Login';

const {
  MODULE_NAME, MODULE_PATH, SHOW_IN_NAV, PROTECTED,
} = config;

const routes = [
  {
    name: MODULE_NAME,
    path: MODULE_PATH,
    component: Login,
    showInNav: SHOW_IN_NAV,
    isProtected: PROTECTED,
  },
];

export default routes;
